import { createSignalRContext } from 'react-signalr/signalr';

export const SignalRContext = createSignalRContext();
